/*
 * Copyright 2024 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { isJenkinsAvailable } from '../components/Router';

/**
 * @alpha
 */
export const entityLatestJenkinsRunCard = EntityCardBlueprint.makeWithOverrides(
  {
    name: 'latest-run',
    config: {
      schema: {
        branch: z => z.string().default('master'),
        variant: z => z.enum(['flex', 'fullHeight', 'gridItem']).optional(),
      },
    },
    factory(originalFactory, { config }) {
      return originalFactory({
        filter: isJenkinsAvailable,
        loader: async () =>
          import('../components/Cards').then(m => (
            <m.LatestRunCard {...config} />
          )),
      });
    },
  },
);

/**
 * @alpha
 */
export const entityJobRunsTable = EntityCardBlueprint.make({
  name: 'job-runs',
  params: {
    filter: isJenkinsAvailable,
    loader: () =>
      import('../components/JobRunsTable').then(m => <m.JobRunsTable />),
  },
});
